import { AxiosInstance, AxiosResponse } from 'axios';
import {
  UserInfoResultDto,
  NavigationResultDto,
  ClientProfileDto,
  UpdateClientProfileDto,
  CreateClientProfileDto,
} from '../types/types';
import { ThemesData } from 'interfaces/ThemesData';
import { toFormData } from './helpers';

const getClientProfileFullPath = (path = ''): string => {
  return `/client-profiles/${path}`;
};

const getCookieConfigFullPath = (configName: string): string => {
  return `/api/cookie-config/${configName}`;
};

export const webframeApi = (http: AxiosInstance | null) => {
  if (!http) {
    return null;
  }

  return {
    getNavigationData: () => {
      return http.get<NavigationResultDto>('/navigation');
    },
    getUserInfo: () => {
      return http.get<UserInfoResultDto>('/user-info');
    },
    getClientProfile: (clientProfileId: string) => {
      return http.get<ClientProfileDto>(getClientProfileFullPath(clientProfileId));
    },
    getAllClientsWithProfile: () => {
      return http.get<string[]>(getClientProfileFullPath('clients'));
    },
    createClientProfile: (clientProfile: CreateClientProfileDto) => {
      const jsonContentTypeHeaderConfig = {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      };

      return http.post(getClientProfileFullPath(), clientProfile, jsonContentTypeHeaderConfig);
    },
    updateClientProfile: (clientProfile: UpdateClientProfileDto) => {
      const formData = toFormData(clientProfile);

      const jsonContentTypeHeaderConfig = {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      };
      return http.put(getClientProfileFullPath(), formData, jsonContentTypeHeaderConfig);
    },
    deleteClientProfile: (id: string) => {
      return http.delete(getClientProfileFullPath(id));
    },
    getClientProfiles: async (url: string): Promise<AxiosResponse<ThemesData>> => http.get(url),
    downloadClientProfileFile: async (
      client: string,
      fileType: string
    ): Promise<AxiosResponse<Blob> | null> => {
      const downloadClientProfileUrl = getClientProfileFullPath(`${client}/download/${fileType}`);

      const response = await http.get(downloadClientProfileUrl, {
        responseType: 'blob',
      });

      // If the status code is 204, return null instead of the response data
      if (response.status === 204) {
        return null;
      }

      return response;
    },
    getCookieConfig: () => {
      const cookieConfigUrl = getCookieConfigFullPath('cookies');

      return http.get(cookieConfigUrl);
    },
    getCookieDeclarationConfig: () => {
      const cookieDeclarationConfigUrl = getCookieConfigFullPath('cookie-declaration');

      return http.get(cookieDeclarationConfigUrl);
    },
  };
};
